import { MediaThumb, useMedia } from '@/features/media';

/** Collections carry a media id only; the thumb resolves lazily from the media cache. */
export function CollectionThumb({
  mediaId,
  className = 'size-10 shrink-0 rounded-md border',
}: {
  mediaId: string | null;
  className?: string;
}) {
  const { data } = useMedia(mediaId);
  return <MediaThumb media={data} className={className} />;
}
